import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const CurrencyList = () => {

    const fields = [
        { title: "Name", fieldName: "name" },
        { title: "Code", fieldName: "currencyCode" },
        { title: "Symbol", fieldName: "symbolCode" },
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.Currency} />
        </>
    )
}

export default CurrencyList;